<template>
  <BaseLayout>
    <template v-slot:top_buttons>
      <div class="demo-inline-spacing">
        <button type="button" class="btn btn-outline-secondary waves-effect" @click="importMinPrices">
          Импорт РРЦ
        </button>
        <button type="button" class="btn btn-outline-secondary waves-effect" @click="importCosts">
          Импорт себестоимоси
        </button>
        <button type="button" class="btn btn-primary" @click="createProduct">
          Новый товар
        </button>
      </div>
    </template>

    <BaseModal ref="productModal" :modal-title="modalTitle">
      <ProductForm ref="productForm" @product-success="productSuccess">

      </ProductForm>
    </BaseModal>

    <BaseModal ref="importModal" :modal-title="importModalTitle">
      <ProductImportFileForm ref="ProductImportFileForm" @file-success="fileSuccess">

      </ProductImportFileForm>
    </BaseModal>

    <BaseModal ref="certificatesModal" :modal-title="certificatesModalTitle">
      <ProductCertificates
          v-if="selectedProduct"
          :product-id="selectedProduct.id"
          :product-brand="selectedProduct.brand"
          @changed="certificatesChanged"
      />
    </BaseModal>

    <div class="card">
      <div class="card-body">
        <div class="row gy-sm-1">
          <div class="col-md-3">
            <div class="input-group input-group-merge shadow-none">
              <input type="text" class="form-control border-1 py-2" placeholder="Поиск по названию"
                     v-model="searchData.name" @change="search">
            </div>
          </div>
          <div class="col-md-3">
            <div class="input-group input-group-merge shadow-none">
              <input type="text" class="form-control border-1 py-2" placeholder="Поиск по бренду"
                     v-model="searchData.brand" @change="search">
            </div>
          </div>

          <div class="col-md-3">
            <Select v-model="searchData.has_active_certificate" :options="certificateFilterOptions"
                    optionLabel="name" optionValue="value" placeholder="Сертификаты" showClear
                    style="width: 100%" @change="search"/>
          </div>

          <div class="col-md-3">
            <div class="input-group input-group-merge shadow-none">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="searchData.disabled" id="disable-check" @change="search">
                <label class="form-check-label" for="disable-check"> Скрытые из поиска товары</label>
              </div>
            </div>
          </div>

        </div>
        <div v-if="!products.length && !productsLoading" class="mt-7">
          Товары не найдены
        </div>
      </div>
      <LoadingBlock :loading="productsLoading">
        <div class="table-responsive text-nowrap">
          <table class="table">
            <thead>
            <tr>
              <th>Товар</th>
              <th>ТН ВЭД</th>
              <th>Сертификаты</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(product, index) in products" :key="index">
              <td><a href="#" @click.prevent="editProduct(product)">{{ product.name }}</a></td>
              <td>{{ product.tnved || '—' }}</td>
              <td>
                <a href="#" @click.prevent="openCertificates(product)">
                  {{ formatProductCertificatesSummary(product.active_certificates_count, product.active_certificate_numbers) }}
                </a>
              </td>
              <td style="text-align: right">
                <button type="button" class="btn btn-icon btn-label-primary waves-effect d-inline-block m-1"
                        @click="editProduct(product)">
                  <span class="ti ti-edit ti-md"></span>
                </button>
                <button type="button" class="btn btn-icon btn-label-secondary waves-effect d-inline-block"
                        @click="deleteProduct(product.id)">
                  <span class="ti ti-trash ti-md"></span>
                </button>
              </td>
            </tr>
            </tbody>
          </table>

          <BasePagination :info="paginationInfo" ref="productsPagination" @changePage="changePage">
          </BasePagination>
        </div>
      </LoadingBlock>
    </div>
  </BaseLayout>
</template>

<script>
import BaseLayout from '@/layouts/Base.vue'
import {PageInfo} from "@/data/page";
import {user} from "@/data/user";
import {deleteProduct, getProducts} from "@/api/product";
import BaseModal from "@/components/Modal.vue";
import ProductForm from "@/components/forms/Product.vue";
import BasePagination from "@/components/list/Pagination.vue"
import ProductImportFileForm from "@/components/forms/ProductImportFiles.vue";
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import {Select} from "primevue";
import ProductCertificates from "@/components/match/ProductCertificates.vue";
import {formatProductCertificatesSummary} from "@/data/certificate";

export default {
  name: 'ProductsView',
  components: {
    ProductCertificates,
    LoadingBlock,
    ProductImportFileForm,
    ProductForm,
    BaseModal,
    BaseLayout,
    BasePagination,
    Select,
  },
  data() {
    return {
      products: [],
      searchResultReady: false,
      productsLoading: true,
      modalTitle: 'Новый товар',
      importModalTitle: 'Загрузка себестоимости',
      certificatesModalTitle: 'Сертификаты товара',
      selectedProduct: null,
      paginationInfo: {},
      certificateFilterOptions: [
        {name: 'С актуальным сертификатом', value: 'true'},
        {name: 'Без актуального сертификата', value: 'false'},
      ],
      searchData: {
        name: '',
        brand: '',
        disabled: '',
        has_active_certificate: null,
      }
    }
  },
  methods: {
    formatProductCertificatesSummary,
    async getProducts() {
      this.productsLoading = true
      const result = await getProducts(user.active_company, this.$route.query)
      this.paginationInfo = {
        total: result.data.total,
        pages: result.data.pages,
        page: result.data.page,
        size: result.data.size
      }
      this.products = result.data.items
      this.productsLoading = false
    },
    async search() {
      const query = {...this.$route.query}
      delete query.page
      Object.entries(this.searchData).forEach(([key, value]) => {
        if (value) {
          query[key] = value
        } else {
          delete query[key]
        }
      });
      await this.$router.push({
        path: this.$route.path,
        query: {
          ...query
        }
      })

    },
    setSearch() {
      if (this.$route.query.name) {
        this.searchData.name = this.$route.query.name
      } else {
        this.searchData.name = ''
      }
      if (this.$route.query.brand) {
        this.searchData.brand = this.$route.query.brand
      } else {
        this.searchData.brand = ''
      }
      if (this.$route.query.disabled) {
        this.searchData.disabled = this.$route.query.disabled
      } else {
        this.searchData.disabled = ''
      }
      if (this.$route.query.has_active_certificate) {
        this.searchData.has_active_certificate = this.$route.query.has_active_certificate
      } else {
        this.searchData.has_active_certificate = null
      }
    },
    async createProduct() {
      this.modalTitle = 'Новый товар'
      setTimeout(() => {
        this.$refs.productModal.openModal()
        this.$refs.productForm.updateItem({})
      }, 100)
    },
    async editProduct(item) {
      this.modalTitle = 'Рекдактировать товар'
      setTimeout(() => {
        this.$refs.productModal.openModal()
        this.$refs.productForm.updateItem(item)
      }, 100)
    },
    async deleteProduct(product_id) {
      if (confirm('Вы уверены, что хотите удалить товар?')) {
        await deleteProduct(product_id)
        await this.getProducts()
      }
    },
    async changePage(page) {
      await this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page: page
        }
      });
    },
    setPageInfo() {
      PageInfo.title = 'Товары'
      PageInfo.breadcrumbs = [
        {
          title: 'Главная',
          link: '/'
        },
        {
          title: PageInfo.title
        }
      ]
    },
    importMinPrices() {
      this.importModalTitle = "Загрузка РРЦ"
      this.$refs.importModal.openModal()
      this.$refs.ProductImportFileForm.setImport('minPrices')
    },
    importCosts() {
      this.importModalTitle = "Загрузка себестоимости"
      this.$refs.importModal.openModal()
      this.$refs.ProductImportFileForm.setImport('costs')
    },
    fileSuccess() {
      this.$refs.importModal.closeModal()
    },
    openCertificates(product) {
      this.selectedProduct = product
      this.certificatesModalTitle = `Сертификаты товара: ${product.name}`
      setTimeout(() => this.$refs.certificatesModal.openModal(), 100)
    },
    async certificatesChanged() {
      await this.getProducts()
    },
    async productSuccess() {
      this.$refs.productModal.closeModal()
      await this.getProducts()
    }
  },
  async mounted() {
    this.setPageInfo()
    this.setSearch()
    await user.getUserBase()
    await this.getProducts()
  },
  watch: {
    '$route'() {
      this.setSearch()
      this.setPageInfo()
      this.getProducts()
    }
  }
}
</script>